import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

class ErrorHandler extends Component {

    render() {
        // console.log(this.props)
        return (
            <Dialog
                open={this.props.errorPopupOpen}
                // onRequestClose={()=>this.props.errorPopupClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Connection Lost, Press on Retry when its available
                                </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>this.props.errorPopupClose()} color="primary" autoFocus>
                        Retry
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default ErrorHandler;


// WEBPACK FOOTER //
// ./src/container/ErrorHandler/errorhandler.js